module.exports = require('./toPairsIn');



//////////////////
// WEBPACK FOOTER
// ./~/lodash/entriesIn.js
// module id = 417
// module chunks = 0